module.exports = __webpack_public_path__ + "static/media/rbahn-o-echtzeit~UYQmqrbA.3ba96d9b.svg";